/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import RegistrationStep from 'gatsby-rage-ppc-theme/src/components/atoms/registration-step/index';

export default (props) => {
  return <RegistrationStep {...props} hasTNCModal={true} />;
};
